/** Words of the moderator space that are not in the shared translations. */
export const moderatorCopy = {
  fr: {
    space: "Modération",
    todo: "À traiter",
    todoDescription: "Tout ce qui attend une action de votre part, avec le nombre d'éléments en attente.",
    validateAudio: "Valider des audios",
    contracts: "Contrats",
    contractTabDraft: "À envoyer",
    contractTabSent: "Envoyés",
    contractTabViewed: "Consultés",
    contractTabSigned: "Signés à valider",
    contractTabValidated: "Validés",
    contractsDescription: "Envoyez les contrats aux candidats qui ont réussi le test, suivez leur signature et validez-les.",
    tools: "Outils",
    toolsDescription: "Imports de fichiers, corpus de phrases et annotation.",
    testCorrection: "Corriger les tests",
    /** The admin menu entry and page that oversees every test. */
    qualificationTests: "Tests de qualification",
    testCorrectionDescription: "Notez chaque item sur 10. Le total pondéré décide : 5 ou plus, le candidat passe à l'étape du contrat.",
    payouts: "Demandes de paiement",
    myPay: "Ma rémunération",
    myPayDescription: "Demandez le paiement de votre forfait de modération.",
    assignTemplates: "Contrats publiés",
    open: "Ouvrir",
    nothingWaiting: "Rien en attente",
    waiting: (count: number) => (count > 1 ? `${count} en attente` : "1 en attente"),
    loadingCount: "Chargement",
    countUnavailable: "Indisponible",
    todoTests: "Tests à corriger",
    todoTestsHint: "Des candidats attendent leur note pour passer à la suite.",
    todoContractsToSend: "Contrats à envoyer",
    todoContractsToSendHint: "Tests corrigés et réussis, le contrat n'est pas encore parti.",
    todoContractsToValidate: "Contrats signés à valider",
    todoContractsToValidateHint: "Le contributeur a signé, il reste votre validation finale.",
    todoPayouts: "Demandes de paiement",
    todoPayoutsHint: "Des contributeurs attendent votre avis avant le paiement.",
    todoAudio: "Valider des audios",
    todoAudioHint: "Écoutez les enregistrements en attente et acceptez ou rejetez-les.",
    rejectReasonTitle: "Pourquoi ce test est-il refusé ?",
    rejectReasonDescription: (score: string) => `Le total pondéré est de ${score}/10, sous le seuil de 5. Le candidat verra ce motif.`,
    rejectReasonPlaceholder: "Ex. : prononciation des phonèmes à retravailler",
    rejectReasonConfirm: "Refuser le test",
    rejectReasonRequired: "Le motif est obligatoire pour refuser un test.",
    rejectedToast: "Test refusé",
    rejectedToastDescription: (score: string) => `Note finale : ${score}/10. Le candidat a été prévenu.`,
    rejectFailed: "Le refus n'a pas pu être enregistré.",
  },
  en: {
    space: "Moderation",
    todo: "To do",
    todoDescription: "Everything waiting on you, with how many items are pending.",
    validateAudio: "Validate audio",
    contracts: "Contracts",
    contractTabDraft: "To send",
    contractTabSent: "Sent",
    contractTabViewed: "Viewed",
    contractTabSigned: "Signed, to validate",
    contractTabValidated: "Validated",
    contractsDescription: "Send contracts to candidates who passed the test, follow their signature and validate them.",
    tools: "Tools",
    toolsDescription: "File imports, phrase corpus and annotation.",
    testCorrection: "Grade tests",
    qualificationTests: "Qualification tests",
    testCorrectionDescription: "Grade each item out of 10. The weighted total decides: 5 or more and the candidate moves on to the contract.",
    payouts: "Payout requests",
    myPay: "My pay",
    myPayDescription: "Request the payment of your moderation fee.",
    assignTemplates: "Published contracts",
    open: "Open",
    nothingWaiting: "Nothing waiting",
    waiting: (count: number) => `${count} waiting`,
    loadingCount: "Loading",
    countUnavailable: "Unavailable",
    todoTests: "Tests to grade",
    todoTestsHint: "Candidates are waiting for their grade to move on.",
    todoContractsToSend: "Contracts to send",
    todoContractsToSendHint: "Graded and passed tests whose contract has not been sent yet.",
    todoContractsToValidate: "Signed contracts to validate",
    todoContractsToValidateHint: "The contributor signed, your final validation is left.",
    todoPayouts: "Payout requests",
    todoPayoutsHint: "Contributors are waiting for your review before being paid.",
    todoAudio: "Validate audio",
    todoAudioHint: "Listen to pending recordings and accept or reject them.",
    rejectReasonTitle: "Why is this test rejected?",
    rejectReasonDescription: (score: string) => `The weighted total is ${score}/10, under the pass mark of 5. The candidate will see this reason.`,
    rejectReasonPlaceholder: "E.g. phoneme pronunciation needs work",
    rejectReasonConfirm: "Reject the test",
    rejectReasonRequired: "A reason is required to reject a test.",
    rejectedToast: "Test rejected",
    rejectedToastDescription: (score: string) => `Final grade: ${score}/10. The candidate has been notified.`,
    rejectFailed: "The rejection could not be saved.",
  },
};

export type ModeratorCopy = (typeof moderatorCopy)["fr"];

export const moderatorCopyFor = (lang: string | undefined): ModeratorCopy => (lang === "en" ? moderatorCopy.en : moderatorCopy.fr);
